import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Grid from '@blocks/Grid'
import React from 'react'
import VotingBestAuthor from './components/BestAuthor/VotingBestAuthor'
import VotingLimits from './components/Limits'
import VotingActions from './components/VotingActions'
import VotingJuries from './components/VotingJuries'
import VotingDashboardContext from './context'

export default function VotingDashboard() {
    const { salon } = useSalonManagerContext()
    const voting = salon.api.dashboard.voting.use()

    if (!voting.data)
        return null

    return (
        <VotingDashboardContext.Provider value={{ voting } as Admin.Contexts.SalonDashboardVoting}>
            <Grid>
                <VotingJuries />
                <VotingLimits />
                <VotingBestAuthor />
                <VotingActions />
            </Grid>
        </VotingDashboardContext.Provider>
    )
}